import Lottie from 'lottie-react';

import lottieCaseNotes from '../jsons/case-notes.json';

const LottieCaseNotes = props => {
  return <Lottie animationData={lottieCaseNotes} loop={false} {...props} />;
};

export default LottieCaseNotes;
